import { navigation } from '@exploration/cms-constants';

export const getDefaultData = () => ({
  callToAction: {},
  image: {},
  list: {},
  text: {
    [navigation.footer_links.footer_top_title]: 'Where Money Means More',
  },
  video: {},
});
